export default __webpack_public_path__ + "static/media/image-activity-empty-graphic.0a9f83eb.svg";